// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about[data-v-d29ab1f0]  .row{-webkit-box-align:center;align-items:center}.about[data-v-d29ab1f0]  .row .col-12:nth-of-type(4){padding:0}.about-img[data-v-d29ab1f0]{-webkit-transform:translateY(14%);transform:translateY(14%)}.about-img img[data-v-d29ab1f0]{width:100%}", ""]);
// Exports
module.exports = exports;
